const CoachTip = () => {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-6 shadow-lg text-white mb-8 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl"></div>
        <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-white opacity-10 rounded-full blur-xl"></div>
        
        <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-shrink-0">
                 <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center text-2xl border border-white/30 backdrop-blur-sm">
                    🤖
                 </div>
            </div>
            
            <div className="flex-1 w-full">
                <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-bold uppercase tracking-wider bg-white/20 px-2 py-0.5 rounded text-indigo-50 border border-white/10">AI Coach Tip</span>
                </div>
                <h3 className="text-lg font-bold mb-1">Post tonight at 7:00 PM</h3>
                <p className="text-indigo-100 text-sm mb-3 max-w-xl">
                    Your followers are most active on Thursday evenings. You usually get <strong>20% higher views</strong> when posting around this time.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3">
                    <button className="w-full sm:w-auto bg-white text-indigo-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 transition shadow-sm text-center">
                        Schedule a Post
                    </button>
                    <button className="w-full sm:w-auto text-white/90 hover:text-white px-3 py-2 text-sm font-medium transition text-center">
                        Remind me later
                    </button>
                </div>
            </div>
        </div>
    </div>
  );
};

export default CoachTip;
